import { toast } from '@ohif/ui-next';
import React, { useState } from 'react';
import { apiUrl } from '../../UploadDocument/apiUrl';
import { DicomMetadataStore } from '@ohif/core';

const DeleteDicomSend = ({
  sopInstanceUid,
  seriesNumberCont,
}: {
  sopInstanceUid: string;
  seriesNumberCont: any;
}) => {
  const [loading, setLoading] = useState(false);
  // const studyMeta = DicomMetadataStore.getSeries()
  // if (!studyMeta) {
  //   toast.error('No se encontró el estudio');
  //   return;
  // }
  const host = '147.93.3.171';
  const port = 11112;
  const calledAET = 'MEDVIEWER';
  const callingAET = 'MAYU';
  // const handleLog = () => {
  //   console.log(seriesNumberCont);
  // };
  // const handleDelete = async () => {
  //   const res = window.confirm('¿Estás seguro de que deseas eliminar este DICOM?');
  //   if (!res) {
  //     toast.info('Eliminación de DICOM cancelada.');
  //     return;
  //   }

  //   setLoading(true);

  //   const requestData = {
  //     host,
  //     port,
  //     calledAET,
  //     callingAET,
  //     sopInstanceUid,
  //   };

  //   try {
  //     const response = await fetch(apiUrl + '/api/dicom/delete', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(requestData),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Error al eliminar el DICOM');
  //     }

  //     toast.success('DICOM eliminado correctamente.');
  //   } catch (error) {
  //     toast.error('Hubo un error al eliminar el DICOM: ' + error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleDeleteAll = async () => {
    const res = window.confirm(
      '¿Estás seguro de que deseas eliminar todos los DICOM de este estudio?'
    );
    if (!res) {
      toast.info('Eliminación de DICOM cancelada.');
      return;
    }

    setLoading(true);

    try {
      for (const item of seriesNumberCont) {
        const requestData = {
          host,
          port,
          calledAET,
          callingAET,
          sopInstanceUid: item.SOPInstanceUID, // enviamos cada SOPInstanceUID
        };

        const response = await fetch(apiUrl + '/api/dicom/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          const errText = await response.text();
          console.error('Error al eliminar SOPInstanceUID:', item.SOPInstanceUID, errText);
          toast.error(`Error eliminando ${item.SOPInstanceUID}`);
          continue; // seguimos con los demás
        }

        toast.success(`DICOM ${item.SOPInstanceUID} eliminado correctamente.`);
      }
    } catch (error) {
      console.error('Error general al eliminar DICOM:', error);
      toast.error('Hubo un error al eliminar los DICOM: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full items-center justify-center">
      {/* Botón para eliminar */}
      <button
        onClick={handleDeleteAll}
        className="flex h-full w-full justify-center"
        disabled={loading}
      >
        {loading ? 'Eliminando...' : 'Eliminar'}
      </button>
    </div>
  );
};

export { DeleteDicomSend };
